import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import ScrollToTop from './components/ScrollToTop';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import DashboardHome from './pages/Dashboard/DashboardHome';
import DashboardDetalhesAnuncio from './pages/Dashboard/DashboardAnuncios/DashboardDetalhesAnuncio';
import DashboardEditarAnuncio from './pages/Dashboard/DashboardAnuncios/DashboardEditarAnuncio';
import DashboardAnuncios from './pages/Dashboard/DashboardAnuncios';
import DashboardLogsAcessos from './pages/Dashboard/DashboardLogs/DashboardLogsAcessos';
import DashboardLogsErros from './pages/Dashboard/DashboardLogs/DashboardLogsErros';
import DashboardLogsFormularios from './pages/Dashboard/DashboardLogs/DashboardLogsForms';
import DashboardUsuarios from './pages/Dashboard/DashboardUsuarios';
import DashboardNovoUsuario from './pages/Dashboard/DashboardUsuarios/DashboardNovoUsuario';
import DashboardContaUsuario from './pages/Dashboard/DashboardUsuarios/DashboardContaUsuario';
import Veiculosecia from './pages/Veiculosecia';
import VeiculoseciaEstoque from './pages/Veiculosecia/VeiculoseciaEstoque';
import VeiculoseciaHome from './pages/Veiculosecia/VeiculoseciaHome';
import VeiculoseciaAnuncio from './pages/Veiculosecia/VeiculoseciaAnuncio';
import VeiculoseciaFinanciamento from './pages/Veiculosecia/VeiculoseciaFinanciamento';
import VeiculoseciaContato from './pages/Veiculosecia/VeiculoseciaContato';
import NotFound from './pages/NotFound';
import Contatos from './pages/Veiculosecia/Contatos';
import DashboardNovoAnuncioFTP from './pages/Dashboard/DashboardAnuncios/DashboardNovoAnuncioFTP';

function AppRoutes() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Routes>
                <Route path='/' element={<Veiculosecia />}>
                    <Route index element={<VeiculoseciaHome />} />
                    <Route path='estoque' element={<VeiculoseciaEstoque />} />
                    <Route path='anuncio/:id' element={<VeiculoseciaAnuncio />} />
                    <Route path='financiamento' element={<VeiculoseciaFinanciamento />} />
                    <Route path='contato' element={<VeiculoseciaContato />} />
                </Route>
                <Route path='/contatos' element={<Contatos />} />
                <Route path='/login' element={<Login />} />
                <Route path='/dashboard' element={<PrivateRoute><Dashboard /></PrivateRoute>}>
                    <Route index element={<DashboardHome />} />
                    <Route path='anuncios' element={<DashboardAnuncios />} />
                    <Route path='anuncio/novo' element={<DashboardNovoAnuncioFTP />} />
                    <Route path='anuncio/:veiculoId/editar' element={<DashboardEditarAnuncio />} />
                    <Route path='anuncio/:veiculoId/detalhes' element={<DashboardDetalhesAnuncio />} />    
                    <Route path='usuarios' element={<DashboardUsuarios />} />
                    <Route path='usuario/novo' element={<DashboardNovoUsuario />} />
                    <Route path='usuario/conta' element={<DashboardContaUsuario />} />
                    <Route path='logs/acessos' element={<DashboardLogsAcessos />} />    
                    <Route path='logs/erros' element={<DashboardLogsErros />} />
                    <Route path='logs/formularios' element={<DashboardLogsFormularios />} />            
                </Route>
                <Route path='*' element={<NotFound />} />
            </Routes>
        </BrowserRouter >
    );
}

export default AppRoutes;
